import { ArgumentOutOfRangeException } from "../../shared/index.js";
export const elementAt = async (source, index) => {
    if (index < 0) {
        throw new ArgumentOutOfRangeException("index");
    }
    const dataFunc = source.dataFunc;
    switch (dataFunc.type) {
        case 0: {
            const values = await dataFunc.generator();
            if (index >= values.length) {
                throw new ArgumentOutOfRangeException("index");
            }
            else {
                return values[index];
            }
        }
        case 1: {
            const promises = dataFunc.generator();
            if (index >= promises.length) {
                throw new ArgumentOutOfRangeException("index");
            }
            else {
                return await promises[index];
            }
        }
        case 2: {
            const promises = await dataFunc.generator();
            if (index >= promises.length) {
                throw new ArgumentOutOfRangeException("index");
            }
            else {
                return await promises[index];
            }
        }
    }
};
